import { Datum } from "../../../components/docs/Datum.js";
import { note, p, table } from "../blocks.js";
import { QUOTED } from "../thresholds.js";
import type { WikiTopic } from "../types.js";

export const volumeBreakout: WikiTopic = {
  slug: "volume-breakout",
  title: "Volume breakout",
  summary: "A bucket that broke its range on a multiple of median volume.",
  group: "strategies",
  horizon: "session",
  strategyKey: "volume_breakout",
  sections: [
    {
      heading: "What it looks for",
      code: "volume_breakout_bullish / volume_breakout_bearish",
      blocks: [
        p(
          <>
            One hourly bucket whose volume reaches <Datum>{QUOTED.VOLUME_BREAKOUT_MULTIPLE}×</Datum>{" "}
            the baseline. The baseline is the median volume of the previous{" "}
            <Datum>{QUOTED.VOLUME_BREAKOUT_WINDOW}</Datum> buckets, not the mean: one block deal in
            the window moves a mean enough to suppress the next real breakout for weeks.
          </>,
        ),
        p(
          <>
            Direction comes from the bar body. A close above the open is bullish, and anything else
            is bearish.
          </>,
        ),
        note(
          <>
            A doji is therefore bearish. That is a deliberate coin flip rather than a third signal
            type, because a type that fired on "the volume arrived and said nothing" would have
            nothing to vote for in confluence.
          </>,
        ),
      ],
    },
    {
      heading: "The gates",
      blocks: [
        table(
          "Volume breakout gates",
          ["Gate", "Value"],
          [
            ["Baseline window", <Datum key="w">{QUOTED.VOLUME_BREAKOUT_WINDOW} buckets</Datum>],
            ["Volume multiple", <Datum key="m">{QUOTED.VOLUME_BREAKOUT_MULTIPLE}×</Datum>],
            ["Minimum history", <Datum key="b">{QUOTED.VOLUME_BREAKOUT_WINDOW + 1} buckets</Datum>],
          ],
        ),
      ],
    },
    {
      heading: "What the row carries",
      blocks: [
        p(
          <>
            Magnitude is the raw volume multiple, not a distance in ATR. It is not comparable with
            the magnitude on an EMA cross.
          </>,
        ),
        p(
          <>
            Stop and target are both <Datum>null</Datum>, on purpose. Nothing in the setup measures
            a level, and a level nothing measured is worse than no level. The feed marks these rows
            "no levels".
          </>,
        ),
      ],
    },
  ],
};
